module.exports = __webpack_public_path__ + "media/images/check-payment-ef1aca1b0d47fa1e1d56ee152b6483b4.svg";